export default () => {
  return {
    default: {
      wrap: {
        '& > svg': {
          marginInlineEnd: '8px',
        },
      },
    },
  } as const
}
